export default __webpack_public_path__ + "static/media/header.f1a0ab84.svg";